import { split, join, capitalize, uniq } from 'lodash';

/**
 * Convert array of underscored strings to humanized string
 *
 * @export
 * @param {Array<String>} arr
 * @returns String
 */
export function arrToStr(arr) {
  arr = uniq(arr);

  const str = join(arr, ', ');

  return humanize(str);
}

/**
 * Convert underscored string to humanized string
 *
 * @export
 * @param {String} str
 * @returns String
 */
export function humanize(str) {
  str = join(split(str, '_'), ' ');
  str = capitalize(str);

  return str;
}

export const hasUppercase = string => {
  return /[A-Z]/.test(string);
};

export const hasLowercase = string => {
  return /[a-z]/.test(string);
};

export const hasNumber = string => {
  return /[0-9]/.test(string);
};

export const hasSpecialChar = string => {
  return /[^a-zA-Z\d\s:]/.test(string);
};
